import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from '../../../../../../common/services/toaster.service';
import { GRouteLogService } from '../../../../../../features/g-route/services/g-route-log.service';
import { GtrakAuthService } from '../../../../../../features/authentication/services/gtrak-auth.service';
import { IRouteLogModel } from '../../../../../../features/g-route/models/route-log.model';
import { RouteDeliveryDetailsService } from '../../../../../../features/g-route/services/route-delivery-details.service';
import { MailService } from '../../../../../../features/g-route/services/mail.service';
import { LogType } from '../../../route-page/route.page';
import { ViewWillEnter } from '@ionic/angular';
import { RouteModel } from '../../../../../../../app/features/g-route/models/route.model';
import { GRouteService } from '../../../../../../../app/features/g-route/services/g-route.service';
import { ModalController } from '@ionic/angular';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import {CommonService} from '../../../../../../common/services/common.service'
@Component({
  selector: 'app-check-out-page',
  templateUrl: 'check-out.page.html',
  styleUrls: [
     './check-out.page.scss',
     '../../../../styles/g-route.styles.scss'
  ]
})
export class CheckOutPage implements OnInit, ViewWillEnter {

    logType = LogType;

    currentRoute: string;
    gRoute: RouteModel = null;
    stopName: string;
    cancelStatus: string;
    garmentStatus: string;
    emailStatus: string;
    isEmailCompleted:boolean=false;
     isCancelCompleted:boolean=false;
     isGarmentCompleted:boolean=false;
    messageCode: string;
    garmentCode: string;
    breadcrumbs=[];
    loaded:boolean=false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toasterService: ToasterService,
        private routeLogService: GRouteLogService,
        public authService: GtrakAuthService,
        private routeDeliveryDetailsService: RouteDeliveryDetailsService,
        private mailService: MailService,
        private gRouteService: GRouteService,
        private modalController: ModalController,
        private commonService:CommonService,
        
    ) { 
        this.currentRoute = null;
    }

    ngOnInit(): void {
        this.loaded=false;
        this.currentRoute = this.router.url;
        this.stopName = this.route.snapshot.paramMap.get('id');
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopName });
        this.loaded=true;
    }

    async ionViewWillEnter(): Promise<void> {
        this.loaded=false
        await this.checkStatus();
        this.loaded=true;
    }

    async completeCheckOut(): Promise<void> {
        //check if any status is Todo
        if(this.cancelStatus === "Todo" || this.garmentStatus === "Todo" || this.emailStatus === "Todo") {
            this.toasterService.presentToast('danger', '', 'Ensure all items are complete', 1000);
            return;
        }
        const modal = this.modalController.create({
                component: ConfirmationPopupComponent,
                cssClass: "min-width-modal",
                showBackdrop: true,
                componentProps: {
                    stop: this.stopName,
                    event: 'check out'
                },
                backdropDismiss: true,
                keyboardClose: true,
                swipeToClose: true,
            });
    
            (await modal).present();
            const {data} = await (await modal).onDidDismiss();
    
            if (data) {
                var estDate=new Date(new Date());
                const log: IRouteLogModel = {
                    logType: this.logType.CHECK_OUT,
                    routeCode: this.authService.user.routeCode,
                    stopCode: this.stopName,
                    odometer: 0,
                    time: estDate, 
                    driverCode: (this.authService.user.id as string)
                };

        const response = await this.routeLogService.createRouteLog(log);

        if (response) {
            this.toasterService.presentToast('primary', '', 'Check out complete', 2000);
            this.router.navigate([`/route/logsheet/stop/${this.stopName}`]);
        } else {
            this.toasterService.presentToast('danger', '', 'An error occurred processing check out request', 2000);
        }
    }
    }

    async checkStatus(): Promise<void> {
        this.loaded=false;
        const today=new Date(new Date());
        //check cancel status
        await this.routeLogService.checkCancel(this.authService.user.routeCode, this.stopName, this.authService.user.id as string, today).then((cancels) => {
            this.routeLogService.hasCancels(this.stopName).then((hasCancels) => {
                if(hasCancels.length === 0 && cancels.length === 0) {
                    const log: IRouteLogModel = {
                        routeCode: this.authService.user.routeCode,
                        stopCode: this.stopName,
                        driverCode: (this.authService.user.id as string),
                        logType: 5,
                        time: today,
                        comment: "Cancel Check N/A"
                    }
                    this.routeLogService.logCancel(log);
                    this.cancelStatus = "N/A";
                    return;
                }
                if(cancels.length > 0) {
                    this.cancelStatus = "Complete";
                } else {
                    this.cancelStatus = "Todo";
                }
            });
        });
        //get garment status
        this.gRoute = await this.gRouteService.get(
            this.authService.user.routeCode
        );
      
        const frequencyDate = this.gRoute.frequencyOffset(
            this.authService.user.routeDate
        );
          const todayeStr= this.commonService.getDateOnly(today);
       await  this.routeDeliveryDetailsService.GetPickupList(this.stopName, this.authService.user.routeCode, todayeStr, frequencyDate).then((data) => {
        if(data.length === 0) {
                this.garmentStatus = "N/A";
            }
            else {
                //loop over the items and check if not numeric
                let hasNonNumeric = false;
                data.forEach((item) => {
                    if(isNaN(+item.qtyAsString)) {
                        hasNonNumeric = true;
                    }
                });

                if(hasNonNumeric) {
                    this.garmentStatus = "Todo";
                }
                else {
                    this.garmentStatus = "Complete";
                }
            }
        });
        //get email status
       await  this.mailService.getMailStatus(this.stopName).then((status) => {

            if(status.numContacts === 0) {
                this.emailStatus = "N/A";
            } else if(status.mailSent === 0) {
                this.emailStatus = "Todo";
            } else {
                this.emailStatus = "Complete";
            }
        });
          this.loaded=true;
    }

    cancelLink(): void {    
        this.router.navigate([`/route/logsheet/stop/${this.stopName}/cancel-report`]);
    }

    garmentLink(): void {
        this.router.navigate([`/route/logsheet/stop/${this.stopName}/non-garments`]);
    }

    emailLink(): void {
        this.router.navigate([`/route/logsheet/stop/${this.stopName}/email-report`]);
    }



}